import { DaymapQuery as o } from "../daymapQuery.js";
import { AzureUploadArgs as y } from "../../components/files/upload/AzureUploadArgs.js";
var r;
((t) => {
  class u extends o {
    constructor({ FileType: e, LinkID: s = 0, OwnerID: l = 0, Flags: a = 0, enabled: n = !0 }) {
      super(
        ["FileList", e, s, l, a],
        { FileType: e, LinkID: s, OwnerID: l, Flags: a },
        `/lms/api/files/filelist?fileType=${e}${s ? "&linkId=" + s : ""}${l ? "&ownerId=" + l : ""}${a ? "&flags=" + a : ""}`,
        null,
        {
          stale: 1e3 * 60 * 5,
          enabled: n,
          select: (d) => d.map((p) => ({ ...p, Modified: new Date(p.Modified) }))
        }
      );
    }
  }
  t.FileList = u;
  class c extends o {
    constructor({ FileId: e, ContentProvider: s = 0, Pdf: l = !1, enable: a = !1 }) {
      super(
        ["FileDownLoadLink", e, s, l],
        { FileId: e, ContentProvider: s, Pdf: l },
        `/lms/api/files/file/downloadurl/${e}?${s ? "&contentproviderType=" + s : ""}${l ? "&pdf=" + l : ""}`,
        null,
        {
          stale: 1e3 * 60 * 5,
          enabled: a,
          select: (n) => n.url
        }
      );
    }
  }
  t.FileDownLoadLink = c;
  class f extends o {
    constructor({ FileId: e, ContentProvider: s = 0, Pdf: l = !1, enable: a = !1, asBlob: n = !1 }) {
      super(
        ["FileBytes", e, s, l],
        { FileId: e, ContentProvider: s, Pdf: l },
        `/lms/api/files/file/${e}?${s ? "&contentproviderType=" + s : ""}${l ? "&pdf=" + l : ""}`,
        { asBlob: n },
        {
          stale: 1e3 * 60 * 5,
          enabled: a
        }
      );
    }
  }
  t.FileBytes = f;
  class m extends o {
    constructor(e) {
      super(
        ["FileInfo", e],
        { fileId: e },
        `/lms/api/files/info/${e}`,
        null,
        {
          stale: 1e3 * 60 * 5
        }
      );
    }
  }
  t.FileInfo = m;
  class $ extends o {
    constructor(e) {
      super(
        ["UploadSasToken", e.type, e.parameters],
        e,
        y.getSasEndpoint(e.type, e.parameters),
        null,
        {
          enabled: !1
        }
      );
    }
  }
  t.UploadSasToken = $;
})(r || (r = {}));
export {
  r as files
};
//# sourceMappingURL=index.js.map
